import { Category } from '../types';

/**
 * Privacy Act Categories with their questions
 */
export const PRIVACY_ACT_CATEGORIES: Category[] = [
  {
    id: 'app-1',
    title: 'APP 1: Open and transparent management of personal information',
    shortHeading: 'Transparent Management',
    question: {
      id: 'app-1-question',
      text: 'Do you have a clear, up-to-date privacy policy on your website that explains how you handle personal information, and do you have simple steps for dealing with privacy questions or complaints?',
      shortHeading: 'Transparent Management'
    }
  },
  {
    id: 'app-2',
    title: 'APP 2: Anonymity and pseudonymity',
    shortHeading: 'Anon and Pseudon',
    question: {
      id: 'app-2-question',
      text: 'Where practical and legal, do you let people contact or buy from you without giving their real name (or by using a nickname), and do you tell them this option exists?',
      shortHeading: 'Anon and Pseudon'
    }
  },
  {
    id: 'app-3',
    title: 'APP 3: Collection of solicited personal information',
    shortHeading: 'Collection of Solicited',
    question: {
      id: 'app-3-question',
      text: 'Do you only collect the personal information you genuinely need for your business, collect it in fair and lawful ways (usually directly from the person themselves), and get consent before collecting sensitive information (like health details)?',
      shortHeading: 'Collection of Solicited'
    }
  },
  {
    id: 'app-4',
    title: 'APP 4: Dealing with unsolicited personal information',
    shortHeading: 'Dealing with Unsolicited',
    question: {
      id: 'app-4-question',
      text: 'If someone gives you personal information you didn\'t ask for, do you quickly decide whether you were allowed to collect it, and if not, delete or de-identify it as soon as it\'s reasonable to do so?',
      shortHeading: 'Dealing with Unsolicited'
    }
  },
  {
    id: 'app-5',
    title: 'APP 5: Notification of the collection of personal information',
    shortHeading: 'Notification of Collection',
    question: {
      id: 'app-5-question',
      text: 'When you collect personal information, do you tell people (either at the time or as soon as practicable) who you are, why you\'re collecting it, who you might share it with (including overseas), and how they can access or correct it?',
      shortHeading: 'Notification of Collection'
    }
  },
  {
    id: 'app-6',
    title: 'APP 6: Use or disclosure of personal information',
    shortHeading: 'Use or Disclosure',
    question: {
      id: 'app-6-question',
      text: 'Do you only use or share personal information for the reason you collected it, unless: you have consent; the person would reasonably expect it; or the law clearly allows it?',
      shortHeading: 'Use or Disclosure'
    }
  },
  {
    id: 'app-7',
    title: 'APP 7: Direct marketing',
    shortHeading: 'Direct Marketing',
    question: {
      id: 'app-7-question',
      text: 'If you do direct marketing, do you only contact people when you have consent or a reasonable basis, and do you include a simple, free opt-out in every message and honour it promptly?',
      shortHeading: 'Direct Marketing'
    }
  },
  {
    id: 'app-8',
    title: 'APP 8: Cross-border disclosure of personal information',
    shortHeading: 'Cross-Border Disclosure',
    question: {
      id: 'app-8-question',
      text: 'Before sending personal information overseas (or using an overseas service provider), do you check that they will protect it to Australian standards, or else get the person\'s informed consent, and only disclose in line with APP 6?',
      shortHeading: 'Cross-Border Disclosure'
    }
  },
  {
    id: 'app-9',
    title: 'APP 9: Use of Government related identifiers',
    shortHeading: 'Government Identifiers',
    question: {
      id: 'app-9-question',
      text: 'Do you avoid using government numbers (like Medicare or driver licence numbers) as your own customer IDs, and avoid sharing them, unless the law says you can?',
      shortHeading: 'Government Identifiers'
    }
  },
  {
    id: 'app-10',
    title: 'APP 10: Quality of personal information',
    shortHeading: 'Quality',
    question: {
      id: 'app-10-question',
      text: 'Do you take reasonable steps to keep personal information accurate, up-to-date, complete and relevant, and make it easy for people to update their details?',
      shortHeading: 'Quality'
    }
  },
  {
    id: 'app-11',
    title: 'APP 11: Security of personal information',
    shortHeading: 'Security',
    question: {
      id: 'app-11-question',
      text: 'Do you protect personal information from misuse, interference, loss, and unauthorised access or disclosure, and securely delete or de-identify it when you no longer need it (unless a law requires you to keep it)?',
      shortHeading: 'Security'
    }
  },
  {
    id: 'app-12',
    title: 'APP 12: Access to personal information',
    shortHeading: 'Access',
    question: {
      id: 'app-12-question',
      text: 'Do you let people access their personal information on request in a prompt, straightforward and low-cost way, and explain how to do this in your privacy policy and notices?',
      shortHeading: 'Access'
    }
  },
  {
    id: 'app-13',
    title: 'APP 13: Correction of personal information',
    shortHeading: 'Correction',
    question: {
      id: 'app-13-question',
      text: 'Do you correct personal information when someone asks, or when you discover it\'s wrong and, when appropriate, tell other organisations you\'ve shared it with about the correction?',
      shortHeading: 'Correction'
    }
  }
];

/**
 * Current questionnaire with version information
 */
export const PRIVACY_ACT_QUESTIONNAIRE = {
  type: 'PRIVACY_ACT',
  version: '1.0.0',
  lastUpdated: '2025-11-26',
  categories: PRIVACY_ACT_CATEGORIES
};
